:host {
  display: block;
}

.price {
  display: inline-flex;
  flex-direction: column;
  gap: var(--sc-spacing-xxx-small);
  text-align: var(--sc-product-price-alignment, left);
  justify-content: var(--sc-product-price-alignment, left);

  &__amounts {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: var(--sc-spacing-xx-small);
    justify-content: var(--sc-product-price-alignment, left);
    text-align: var(--sc-product-price-alignment, left);
  }

  &__scratch {
    text-decoration: line-through;
    opacity: 0.75;
  }

  &__interval {
    font-size: min(var(--sc-font-size-small), 16px);
    opacity: 0.75;
  }

  &__details {
    font-size: min(var(--sc-font-size-small), 16px);
    opacity: 0.75;
  }

  &__sale-badge {
    font-size: min(1em, 14px);
    align-self: center;
  }
}
